module.exports = __webpack_public_path__ + "static/media/search.5225ce83.svg";